<template>
    <div class="d-flex align-items-center">
        <label class="switch mb-0">
            <input
                    type="checkbox"
                    v-model="model"
                    :checked="model"
            >
            <span class="slider-switch round"></span>
        </label>
        <span class="ps-2" v-if="$slots.default"><slot></slot></span>
    </div>
</template>
<script>
    export default {
        name: "ToggleSwitch",
        props: {
            value: [ Boolean, Number ]
        },
        computed: {
            model: {
                get() {
                    return !!this.value
                },
                set(val) {
                    this.$emit('input', !!val)
                }
            }
        },
        watch: {
            model: function(val) {
                this.$emit('input', !!val)
            }
        }
    }
</script>